export const inputClass =
  'w-full py-2 px-3 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 outline-none transition-colors';

export const selectClass =
  'w-full py-2 px-3 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-orange-500/30 focus:border-orange-500 outline-none transition-colors appearance-none';

export const labelClass = 'block text-xs font-semibold text-gray-600 mb-1';

export const sectionGap = 'space-y-3';

export const formGap = 'space-y-5';

export const gridGap = 'gap-3';
